import { IMyWindow } from '@my-backoffice/app/shared/interfaces/my-window.interface';
import { EQimaIsoCountryCode, qimaEnumValuesToArray } from '@qima/ngx-qima';

declare let COUNTRY_FLAGS_SRC: string;

/**
 * @description
 * Factory function to generate country flags mapping
 * Uses window.countryFlagsSrc to get the base path for flag images
 * @param {IMyWindow} myWindow The window with qima variables
 * @returns {Record<EQimaIsoCountryCode, string>} Record<EQimaIsoCountryCode, string> - Mapping of country ISO codes to flag image paths
 */
export function countryFlagsFactory(myWindow: IMyWindow): Record<EQimaIsoCountryCode, string> {
  const flags: Record<string, string> = {};
  const basePath = myWindow.countryFlagsSrc ?? COUNTRY_FLAGS_SRC;

  qimaEnumValuesToArray(EQimaIsoCountryCode).forEach((countryIso2: string): void => {
    flags[countryIso2] = `${basePath}/${countryIso2}.svg`;
  });

  return flags;
}
